import { ReactElement } from "react";
import Modify from "@shared/FormTemplates/Modify";
import ModifyForm from "./ModifyForm";
import updateItem from "@services/Clients/WhaleShark/articles/updateItem";
import useGetDetailItem from "@hooks/Clients/WhaleShark/articles/useGetArticle";
import validator from "@validators/Clients/WhaleShark/articles/articles.validate";
import formMapper from "@mappers/Clients/WhaleShark/articles/ArticleItem.mapper";

const ModifyItem = (): ReactElement => (
  <Modify
    CustomForm={ModifyForm}
    modifyHook={updateItem}
    detailHook={useGetDetailItem}
    validator={validator}
    formMapper={formMapper}
  />
);

export default ModifyItem;
